module.exports = __webpack_public_path__ + "img/MartinOld.4b53568a.png";